// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const ColumnsOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M15 4v16M4 14.75h11M4 9.25h11M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12c0 1.1.9 2 2 2z","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","stroke":"#fff"}}]},"name":"columns","theme":"outlined"};

const ColumnsOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={ColumnsOutlinedSvg} />;
  ColumnsOutlined.displayName = 'ColumnsOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(ColumnsOutlined);
